import { GENERAL_DISEASE } from 'utils/constants/disease';
import { getQuestions } from 'new-ui/functions/getQuestions';
import { HCP_QUESTIONS, LOCATION_QUESTION, MOCK_QUESTIONS } from './constants';

export const getIntakeQuestions = async (indication) => {
  let questions = [...MOCK_QUESTIONS];
  if (indication) {
    const allQuestions = await getQuestions(indication);
    questions = allQuestions.filter(({ id: questionId }) => HCP_QUESTIONS[indication].includes(questionId));
  }
  questions.push(LOCATION_QUESTION);
  return questions;
};

export const getIntakeCustomData = ({ user, allQuestions }) => {
  let indication = user?.personal?.condition;
  if (indication === GENERAL_DISEASE) indication = null;
  return {
    sections: ['general', 'other'],
    user,
    questions: [],
    allQuestions: allQuestions.map((question) => {
      // eslint-disable-next-line no-param-reassign
      question.preventTitle = true;
      // eslint-disable-next-line no-param-reassign
      question.className = 'hcp-question';
      if (question.id === 'treatments') {
        // eslint-disable-next-line no-param-reassign
        question.show = true;
      }
      return question;
    }),
    questionsData: {
      general: allQuestions.map(({ id }) => id),
      other: [],
    },
  };
};
